import request from '@/utils/request'

const getCouponById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/coupon/${id}`,
    method: 'get'
  })
}

const getCouponPageList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/coupon/page-list`,
    method: 'get',
    params: query
  })
}

function createCoupon(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/coupon`,
    method: 'post',
    data
  })
}

const updateCoupon = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/coupon/${id}`,
    method: 'put',
    data
  })
}

const getAvailableCoupons = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/coupon/available-coupons`,
    method: 'get'
  })
}

function redeemCoupon(code) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/coupon/redeem-coupon?code=${code}`,
    method: 'post'
  })
}

export default {
  createCoupon,
  updateCoupon,
  getCouponById,
  getCouponPageList,
  getAvailableCoupons,
  redeemCoupon
}
